import React, { useEffect, useState } from 'react';

export default function RequirementsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [processingId, setProcessingId] = useState('');
  const [quotations, setQuotations] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const apiBase = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '');
        const resp = await fetch(apiBase + '/api/requirements');
        const data = await resp.json();
        if (resp.ok && data && data.items) {
          setItems(data.items);
        } else {
          setError('Failed to load requirements');
        }
      } catch (err) {
        setError('Failed to load requirements');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">Requirements</h2>
      {items.length === 0 ? (
        <div className="text-gray-600">No requirements found.</div>
      ) : (
        <div className="overflow-x-auto bg-white rounded shadow">
          <table className="min-w-full divide-y">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Heading</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Created</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y">
              {items.map(item => (
                <tr key={item._id}>
                  <td className="px-6 py-4 text-sm text-gray-700">{item.heading || 'Requirement'}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{new Date(item.createdAt).toLocaleString()}</td>
                  <td className="px-6 py-4 text-sm">
                      <div className="flex items-center gap-2">
                        {item.filePath ? (
                          <a href={(process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '')) + item.filePath} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-blue-600 text-white rounded">Download Document</a>
                        ) : (
                          <span className="text-gray-500">No file</span>
                        )}

                        {/* Generate Quotation */}
                        <button
                          className="px-3 py-1 bg-green-600 text-white rounded"
                          onClick={async () => {
                            if (processingId) return;
                            setProcessingId(item._id);
                            try {
                              const apiBase = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '');
                              const resp = await fetch(apiBase + '/api/requirements/' + item._id + '/generate-quotation', { method: 'POST' });
                              const data = await resp.json();
                              if (resp.ok && data && data.file) {
                                const url = (process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '')) + data.file;
                                setQuotations(prev => ({ ...prev, [item._id]: url }));
                                // Do not auto-download; let admin use the Download Quotation link
                              } else {
                                alert('Failed to generate quotation');
                              }
                            } catch (err) {
                              alert('Failed to generate quotation');
                            } finally {
                              setProcessingId('');
                            }
                          }}
                        >
                          {processingId === item._id ? 'Generating...' : 'Generate Quotation'}
                        </button>

                        {quotations[item._id] && (
                          <>
                            <a href={quotations[item._id]} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-gray-800 text-white rounded">Download Quotation</a>
                            <button
                              className="px-3 py-1 bg-indigo-600 text-white rounded"
                              onClick={async () => {
                                if (processingId) return;
                                setProcessingId(item._id);
                                try {
                                  const apiBase = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '');
                                  const token = localStorage.getItem('token');
                                  const resp = await fetch(apiBase + '/api/requirements/' + item._id + '/email-quotation', {
                                    method: 'POST',
                                    headers: token ? { 'Authorization': `Bearer ${token}` } : {},
                                  });
                                  const data = await resp.json();
                                  if (resp.ok && data && data.success) {
                                    alert(data.message || 'Email sent');
                                  } else {
                                    alert('Failed to send email: ' + (data && data.message ? data.message : 'server error'));
                                  }
                                } catch (err) {
                                  alert('Failed to send email');
                                } finally {
                                  setProcessingId('');
                                }
                              }}
                            >{processingId === item._id ? 'Sending...' : 'Send Mail'}</button>
                          </>
                        )}
                        {/* Send button removed per request */}
                      </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
